import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useProject } from '../contexts/ProjectContext';
import ProjectSelect from '../pages/app/ProjectSelect';

interface ProtectedProjectRouteProps {
  children?: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedProjectRoute: React.FC<ProtectedProjectRouteProps> = ({
  children,
  redirectTo,
}) => {
  const { currentProject, loading, error } = useProject();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !currentProject) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    return <ProjectSelect />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedProjectRoute;
